import {Props_Testimonials} from "./Testimonials.props";
import {CompileMarkdown} from "@ClientBase/React/ReactSnippetMDCompiler";

const Testimonials = (props: Props_Testimonials) => {
    const {user_name, user_testimonial, user_image, background, heading} = props
    
    const backgroundMap = {
        'covea-dark-blue': '#122147',
        'covea-light-green': '#d6eac1',
        'covea-light-red': '#efded3',
        'covea-light-purple': '#e2d3f2',
        'covea-light-turquoise': '#c8eaed',
        'covea-light-yellow': '#eae8ad',
        'MAAF-dark-blue': '#0091a7',
        'MAAF-light-blue': '#e5f3f5',
        'MAAF-light-red': '#fef6f2',
        'MMA-light-green': '#d6eceb',
        'MMA-light-orange': '#f2e1b5',
        'MMA-dark-blue': '#1d3b6d',
        'GMF-dark-blue': '#144390',
        'GMF-light-blue': '#dfedff',
        'GMF-light-orange': '#fff4ed',
        'Fidelia-dark-green': '#269b38',
        'Fidelia-light-blue': '#e1f0fb',
        'Fidelia-light-green': '#ebf2e7'
    }

    const backgroundKey = background?.colour.value || 'colour-1'
    const backgroundValue = backgroundMap[backgroundKey as keyof typeof backgroundMap] || backgroundMap['covea-light-purple']
    const darkBackgrounds = ['covea-dark-blue', 'MAAF-dark-blue', 'MMA-dark-blue', 'GMF-dark-blue', 'Fidelia-dark-green']
    const useWhiteText = darkBackgrounds.includes(backgroundKey) ? 'testimonial--white-text' : ''
    
    return (
        <section className={`testimonial ${useWhiteText}`}>
            <div className={`testimonial__container`} style={{ backgroundColor: backgroundValue }}>
                {heading?.content?.value &&
                    <h2 className={`testimonial__heading accessible-heading`}>{heading.content?.value}</h2>
                }
                <div className={`testimonial__main-content`}>
                    {user_image?.src?.value &&
                        <figure className={`testimonial__image-container`}>
                            <img
                                className={`testimonial__image`}
                                alt={user_image?.alt?.value && user_image.alt.value || ''}
                                loading="lazy"
                                src={user_image?.src?.value}
                                width={200}
                                height={200}
                            />

                        </figure>
                    }
                    <div className={`testimonial__content-container`}>
                        {user_testimonial?.content?.value &&
                            <div className={`testimonial__testimonial`}>
                                {CompileMarkdown(user_testimonial.content.value as string)}
                            </div>
                        }
                        {user_name?.content?.value &&
                            <div className={`testimonial__user-name`}>
                                <p>{user_name.content.value}</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Testimonials;